import { render, staticRenderFns } from "./GeneralContacts.vue?vue&type=template&id=2bda8e3b&"
import script from "./GeneralContacts.vue?vue&type=script&lang=js&"
export * from "./GeneralContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports